export default __webpack_public_path__ + "static/media/entrepreneurship.ee1e8e11.png";